import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';
import { RootState } from '@/src/reducers/types';
import { cn } from '@/src/util/ui';

type CancelUploadProps = {
  classes?: string;
  onClose?: () => void;
  onCancel: () => void;
};

const CancelUpload = ({ classes, onClose, onCancel }: CancelUploadProps) => {
  const conversationFiles = useSelector((store: RootState) => store.conversations.files);
  const hasFiles = conversationFiles.filter((f) => !f.cancelled).length <= 1;

  const handleCancel = () => {
    if (onCancel) {
      onCancel();

      if (hasFiles) {
        $('.text-editor-inner-container').removeClass('uploaderActive');
      }
    }
  };

  return (
    <ModalPopup
      className={cn(classes)}
      id={'upload-cancel'}
      title={'Cancel Upload ?'}
      message={'Would you like to cancel the upload?'}
      modalWidth={clsx('tw-w-[520px]')}
      onClose={onClose}
      onConfirm={handleCancel}
      confirmBtn={{ label: 'Cancel Upload' }}
      cancelBtn={{ label: 'Continue Upload' }}
    />
  );
};

export default CancelUpload;
